/* RNG Therapy – hype automation. Tags: hype-preorder, hype-new, hype-feature, hype-release-YYYY-MM-DD. Dates in Pacific time. */
(function () {
'use strict';
var TZ = 'America/Los_Angeles';
var DAY = 864e5;
var fmt = new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' });
function parts(ms) {
var o = {};
fmt.formatToParts(new Date(ms)).forEach(function (p) { o[p.type] = p.value; });
return o;
}
function todayPT() { var p = parts(Date.now()); return p.year + '-' + p.month + '-' + p.day; }
function validDate(s) { return /^\d{4}-\d{2}-\d{2}$/.test(s || ''); }
function ptEpoch(ymd, h, m) {
var a = ymd.split('-').map(Number);
var guess = Date.UTC(a[0], a[1] - 1, a[2], h || 0, m || 0);
for (var i = 0; i < 2; i++) {
var p = parts(guess);
var asUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second);
guess += Date.UTC(a[0], a[1] - 1, a[2], h || 0, m || 0) - asUTC;
}
return guess;
}
function addDays(ymd, n) {
var a = ymd.split('-').map(Number);
return new Date(Date.UTC(a[0], a[1] - 1, a[2] + n)).toISOString().slice(0, 10);
}
function nextDay(ymd) { return addDays(ymd, 1); }
var WINDOW = 14;
function waiting(rel, today) { return !!rel && today < addDays(rel, -WINDOW); }
function label(ymd, withDay) {
var a = ymd.split('-').map(Number);
var d = new Date(Date.UTC(a[0], a[1] - 1, a[2], 12));
return d.toLocaleDateString('en-US', withDay ? { weekday: 'short', month: 'short', day: 'numeric', timeZone: 'UTC' } : { month: 'short', day: 'numeric', timeZone: 'UTC' });
}
function parseTime(t) {
var m = String(t || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])\.?\s*m?\.?$/i) || String(t || '').trim().match(/^(\d{1,2})(?::(\d{2}))?$/);
if (!m) return [0, 0];
var h = +m[1], mi = +(m[2] || 0);
if (m[3]) { var pm = m[3].toLowerCase() === 'p'; if (h === 12) h = 0; if (pm) h += 12; }
return [Math.min(h, 23), Math.min(mi, 59)];
}
function pad(n) { return (n < 10 ? '0' : '') + n; }
function split(ms) {
ms = Math.max(0, ms);
return { d: Math.floor(ms / DAY), h: Math.floor(ms / 36e5) % 24, m: Math.floor(ms / 6e4) % 60, s: Math.floor(ms / 1e3) % 60 };
}
function shortLeft(ms) {
var t = split(ms);
if (t.d > 0) return t.d + 'd ' + pad(t.h) + 'h';
if (t.h > 0) return t.h + 'h ' + pad(t.m) + 'm';
return t.m + 'm ' + pad(t.s) + 's';
}
function stateOf(tags) {
tags = (tags || []).map(function (t) { return String(t).trim().toLowerCase(); });
var has = function (t) { return tags.indexOf(t) > -1; };
var pre = has('hype-preorder'), nw = has('hype-new'), feat = has('hype-feature');
var rel = '', ships = '';
tags.forEach(function (t) {
if (t.indexOf('hype-release-') === 0 && validDate(t.slice(13))) rel = t.slice(13);
if (t.indexOf('hype-ships-') === 0 && validDate(t.slice(11))) ships = t.slice(11);
});
var today = todayPT();
var end = ships && (!rel || ships > rel) ? ships : rel;
if (end && today > end) return null;
if (waiting(rel, today)) return { kind: 'wait', rel: rel, ships: ships, end: end, target: rel, feature: feat };
var kind = null;
if (end && today === end && (pre || nw)) kind = 'out';
else if (pre) kind = 'pre';
else if (nw) kind = 'new';
var target = rel && today < rel ? rel : end;
return kind ? { kind: kind, rel: rel, ships: ships, end: end, target: target, feature: feat } : null;
}
var BADGE = { pre: 'Pre-order', new: 'New', out: 'Out today' };
var ticking = [];
function clock(el, target, small) {
el.innerHTML = '';
el.className = 'rng-hype-clock' + (small ? ' rng-hype-clock--sm' : '');
el.setAttribute('role', 'timer');
el.setAttribute('aria-live', 'off');
var units = [['d', 'Days'], ['h', 'Hours'], ['m', 'Min'], ['s', 'Sec']].map(function (u) {
var box = document.createElement('div');
box.className = 'rng-hype-clock__u';
box.innerHTML = '<b>00</b><small>' + u[1] + '</small>';
el.appendChild(box);
return [u[0], box.firstChild];
});
var item = { target: target, paint: function (left) { var t = split(left); units.forEach(function (u) { u[1].textContent = pad(t[u[0]]); }); } };
item.paint(target - Date.now());
ticking.push(item);
return item;
}
setInterval(function () {
var now = Date.now();
ticking.forEach(function (it) {
var left = it.target - now;
it.paint(left);
if (left <= 0 && it.done && !it.fired) { it.fired = true; it.done(); }
});
}, 1000);
var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var dataPromise = null;
function hypeData() {
if (dataPromise) return dataPromise;
var key = 'rng-hype-v2';
try {
var c = JSON.parse(sessionStorage.getItem(key) || 'null');
if (c && Date.now() - c.t < 3e5) return (dataPromise = Promise.resolve(c.p));
} catch (e) {}
dataPromise = Promise.all(['hype', 'new-release', 'feature'].map(function (c) {
return fetch(root + 'collections/' + c + '/products.json?limit=250')
.then(function (r) { return r.ok ? r.json() : { products: [] }; })
.catch(function () { return { products: [] }; });
}))
.then(function (all) {
var seen = {}, p = [];
all.forEach(function (j) { (j.products || []).forEach(function (x) { if (!seen[x.handle]) { seen[x.handle] = 1; p.push({ h: x.handle, t: x.tags }); } }); });
try { sessionStorage.setItem(key, JSON.stringify({ t: Date.now(), p: p })); } catch (e) {}
return p;
})
.catch(function () { return []; });
return dataPromise;
}
var map = null;
function handleFrom(href) {
var m = String(href || '').match(/\/products\/([^/?#]+)/);
return m ? decodeURIComponent(m[1]).toLowerCase() : '';
}
function markCards(scope) {
if (!map) return;
(scope || document).querySelectorAll('.product-card-wrapper:not([data-rng-hype])').forEach(function (card) {
card.setAttribute('data-rng-hype', '');
var a = card.querySelector('a[href*="/products/"]');
var st = a && map[handleFrom(a.getAttribute('href'))];
if (!st) return;
var holders = card.querySelectorAll('.card__badge');
var holder = holders[holders.length - 1];
if (holder) {
var b = document.createElement('span');
b.className = 'badge rng-hype-badge rng-hype-badge--' + st.kind;
b.textContent = BADGE[st.kind];
holder.insertBefore(b, holder.firstChild);
}
if (st.kind !== 'pre') card.classList.add('rng-hype-card');
});
}
function initCards() {
hypeData().then(function (list) {
map = {};
var live = false;
list.forEach(function (p) { var st = stateOf(p.t); if (st && st.kind !== 'wait') { map[String(p.h).toLowerCase()] = st; live = true; } });
document.documentElement.classList.toggle('rng-hype-live', live);
markCards();
new MutationObserver(function (muts) {
for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes.length) { markCards(); break; }
}).observe(document.body, { childList: true, subtree: true });
});
}
function initProductBox() {
document.querySelectorAll('[data-rng-hype-box]').forEach(function (box) {
var st = stateOf((box.dataset.tags || '').split(','));
if (!st || st.kind === 'new' || st.kind === 'wait') { box.hidden = true; return; }
var lab = box.querySelector('[data-label]'), date = box.querySelector('[data-date]'), slot = box.querySelector('[data-clock]');
var sh = box.querySelector('[data-ships]'), today = todayPT();
box.hidden = false;
if (sh) { sh.hidden = !st.ships; sh.textContent = st.ships ? 'Ships ' + label(st.ships, true) : ''; }
var nt = box.querySelector('[data-ships-note]'); if (nt) nt.hidden = !st.ships;
if (st.kind === 'out') {
lab.textContent = 'Out today · in stock now';
date.textContent = st.rel ? 'Released ' + label(st.rel, true) : '';
slot.innerHTML = '';
return;
}
lab.textContent = st.ships ? 'Pre-order' : 'Pre-order · ships on release';
date.textContent = st.rel ? (today < st.rel ? 'Releases ' : 'Released ') + label(st.rel, true) : (st.ships ? '' : 'Release date coming soon');
if (st.target) {
var c = clock(slot, ptEpoch(st.target, 0, 0), true);
c.done = function () { initProductBox(); };
} else {
slot.innerHTML = '';
}
});
}
function initPreNote() {
document.querySelectorAll('[data-rng-notices]').forEach(function (el) {
var st = stateOf((el.dataset.tags || '').split(','));
if (!st || (!st.rel && !st.ships)) return;
var fix = function () {
el.querySelectorAll('.rng-note').forEach(function (n) {
if (n.dataset.rngHype || !/^\s*pre-?order/i.test(n.textContent)) return;
n.dataset.rngHype = '1';
if (st.kind !== 'pre') { n.hidden = true; return; }
var today = todayPT(), b = function (d) { return '<strong>' + label(d, true) + '</strong>'; };
n.innerHTML = 'PRE-ORDER — ' + (st.rel ? (today < st.rel ? 'releases ' : 'released ') + b(st.rel) + '. ' : '') + (st.ships ? 'Ships ' + b(st.ships) + '.' : 'Ships on or around release day.');
});
};
fix();
new MutationObserver(fix).observe(el, { childList: true, subtree: true });
});
}
function initLowStock() {
document.querySelectorAll('[data-rng-stock]').forEach(function (el) {
var check = function () {
var s = el.querySelector('.rng-stock__msg strong');
var n = s ? parseInt(s.textContent.replace(/[^\d]/g, ''), 10) : NaN;
el.classList.toggle('rng-hype-low', n > 0 && n <= 5);
};
check();
new MutationObserver(check).observe(el, { childList: true, subtree: true, characterData: true });
});
}
function init() {
initCards();
initProductBox();
initPreNote();
initLowStock();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
window.RNGHype = { stateOf: stateOf, todayPT: todayPT, ptEpoch: ptEpoch, parseTime: parseTime, nextDay: nextDay, addDays: addDays, waiting: waiting, validDate: validDate, label: label, shortLeft: shortLeft, clock: clock, ticking: ticking };
})();